export const Fields = {
    firstname: 'firstname',
    lastname: 'lastname',
    email: 'email',
    password: 'password',
};
